module.exports = __webpack_public_path__ + "static/aerial-views-viii-558998ff2222ffc08d2a8aa4e3124255.jpg";